module.exports = __webpack_public_path__ + "img/NYCSkylineSliveredMoon-Portrait.1e3733a5.jpg";